// Resolve public image URLs for an artifact. Candidate canonical image comes
// from VITE_IMAGE_BASE_URL + canonicalImageKey, falling back to the original
// photo. CONTRACTS §9 / §10.

import { imageUrl } from "./config";
import type { Artifact } from "./types";

export interface ArtifactImageUrls {
  original?: string;
  canonical?: string;
  thumb?: string;
  /** Best display image: canonical if present, else original. */
  best?: string;
}

export function artifactImageUrls(a: Artifact): ArtifactImageUrls {
  const original = imageUrl(a.originalImageKey);
  const canonical = imageUrl(a.canonicalImageKey);
  const thumb = imageUrl(a.thumbnailKey);
  return { original, canonical, thumb, best: canonical ?? original };
}

/** True when the record has only the original photo (no online match). */
export function isPlaceholder(a: Artifact): boolean {
  return a.imageFidelity === "original_placeholder";
}
